import {h} from "preact";

import "./Message.scss";
import {forwardRef} from "preact/compat";
import {useState} from "preact/hooks";
import {API_KEY, Client} from "../../lib/graphql";
import {useQuery} from "@urql/preact";
import { useEffectEveryHourOnTheHour } from "../../lib/useEffectEveryHourOnTheHour";

const CURRENT_TIMESLOT_QUERY = `
            query {
                currentTimeslot {
                    itemId
                }
            }
        `;

const MessageScreen = forwardRef<HTMLDivElement>((props, ref) => {
    const [timeslotIdResult, refetch] = useQuery({
        query: CURRENT_TIMESLOT_QUERY,
        requestPolicy: 'network-only'
    });
    useEffectEveryHourOnTheHour(refetch);
    const [messageText, setMessageText] = useState("");
    const [sendState, setSendState] = useState<"SENDING" | "SUCCESS" | "ERROR" | null>(null);
    const [sendError, setSendError] = useState<string | null>(null);
    const [lastMessageSendTime, setLastMessageSendTime] = useState(-1);

    const timeslotId = timeslotIdResult.data?.currentTimeslot?.itemId;

    async function sendMessage() {
        if (messageText.length < 3 || messageText.length > 3000) {
            setSendState("ERROR");
            setSendError("Please enter a valid message.");
            return;
        }
        if (lastMessageSendTime > (new Date().valueOf() - 20 * 1000)) {
            setSendState("ERROR");
            setSendError("Sorry, please wait a bit before sending another message.");
            return;
        }
        if (!timeslotId) {
            setSendState("ERROR");
            setSendError("Sorry, the current show is not accepting messages.");
            return;
        }
        setSendState("SENDING");
        setSendError(null);
        // TODO: this should probably be a GQL mutation for consistency
        try {
            await fetch(
                `https://ury.org.uk/api/v2/timeslot/${timeslotId}/sendmessage?api_key=${API_KEY}`,
                {
                    method: "put",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        message: messageText
                    })
                }
            );
            setSendState("SUCCESS");
            setLastMessageSendTime(new Date().valueOf());
            setMessageText("");
            setTimeout(() => {
                setSendState(currentState => currentState === "SUCCESS" ? null : currentState);
            }, 5000);
        } catch (e) {
            console.error(e);
            setSendState("ERROR");
            setSendError("Sorry, something went wrong. Please try again.");
        }
    }

    return (
        <div class="message-card card" ref={ref}>
            <h2 class="header-sideline" title="Message into the Show">
                <span class="btn header">
                    Message in
                </span>
                <span class="sideline">to the Show</span>
            </h2>
            <p>Why not send a message to the studio presenters? Have a bit of banter, share your opinions or simply request your favourite song?</p>
            <div class="inner-wrapper">
                <textarea
                    rows={5}
                    placeholder="Make sure to include your name!"
                    value={messageText}
                    onChange={e => setMessageText(e.currentTarget.value)}
                    disabled={sendState === "SENDING"}
                />
                {sendState === "SUCCESS" && <div class="alert success">Message sent!</div>}
                {sendState === "ERROR" && <div class="alert error">{sendError}</div>}
                <button class="send-button" disabled={sendState === "SENDING"} onClick={sendMessage}>Send</button>
            </div>
        </div>
    )
});
export default MessageScreen;
